import { QUERY_KEYS } from "@/constants/QUERY_KEYS";
import * as req from "@script/req";
import useStore from "@store/store";
import { useQuery } from "@tanstack/react-query";
import { useIsAdmin, useIsGroupNurse } from "./useAuth";

export default function useIssuedList(selectedGroupId?: string | null) {
  const { loginUser } = useStore();
  const isAdmin = useIsAdmin();
  const isGroupNurse = useIsGroupNurse();

  const gid = isAdmin || isGroupNurse
    ? (selectedGroupId ?? undefined)
    : (loginUser?.group_id ?? undefined);

  return useQuery<{ year: number; month: number; schedule_id: string }[]>({
    queryKey: QUERY_KEYS.roster.issuedList(gid),
    queryFn: async () => {
      return await req.roster_issued(gid);
    },
    enabled: !!loginUser,
    staleTime: 1000 * 60 * 5, // 5분 캐싱
  });
}
